module.exports = __webpack_public_path__ + "static/media/S1-28-Phroniac-cod48-B.860eb32d.png";